import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

export type Transaction = Awaited<
  ReturnType<typeof CoreApi.meGetGamificationAccountTransactions>
>['transactions'][0];

type Params = {
  limit?: number;
  cursor?: number;
  before?: string;
  accountId: number;
};

export const meGetGamificationAccountTransactions = createQueryFn(
  QueryNameSpace.meGetGamificationAccountTransactions,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const { accountId, ...restParams } = params;

    const res = await CoreApi.meGetGamificationAccountTransactions(accountId, {
      ...restParams,
      cursor: pageParam as number,
    });

    return res;
  },
);
